export default function({ dispatch, commit }, verification) {

    commit('startedAuthentication')

    // POST /auth/verify/email
    return dispatch('post', {
        url: '/auth/verify/connect',
        data: verification,
        query: 'verifyProviderEmail'
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        return response
    })
    .catch((error) => {
        console.log('ERROR', error)
        commit('finishedAuthentication')
        throw error
    })
}
